<template>
  <div class="container">
    <div class="club">
      <v-img :src="expediente.club.logo" height="80" contain width="80"></v-img>
      <p class="club-name"><b>{{ expediente.club.nombre }}</b></p>
    </div>
    <div class="description">
      <p>{{ expediente.description }}</p>
    </div>
    <div class="expediente-info">
      <ul>
        <li>Fecha de apertura: <b>{{ expediente.created }}</b></li>
        <li>Ultima modificación: <b>{{ expediente.modified }}</b></li>
        <li>Tipo de expediente: <b>{{ expediente.type }}</b></li>
        <li>Informe asociado: <b> <span
              :class="this.$store.state.permissions.canViewInformesAuditorias ? `link-style` : ``" @click="goToInforme">{{
                expediente.informeName }}</span></b></li>
        <li>Estado: <b>{{ expediente.state }}</b></li>
        <li v-if="expediente.closedDate !== null">Fecha de cierre: <b>{{ expediente.closedDate }}</b></li>
      </ul>
    </div>
    <div v-if="expediente.match.description" class="expediente-partido-info">
      <ul>
        <li>Partido: <b> <span :class="this.$store.state.permissions.canViewFichaPartidoClub ? `link-style` : ``"
              @click="goToFichaPartido">{{ expediente.match.description }}</span></b></li>
        <li>Día y horario: <b>{{ expediente.match.dateRealization }}</b></li>
        <li>Fecha: <b>{{ expediente.match.fechaName }} - {{ expediente.match.tournamentName }}</b></li>
        <li>Estadio: <b>{{ expediente.match.stadium }}</b></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    expediente: null
  },
  methods: {
    goToFichaPartido () {
      if (this.$store.state.permissions.canViewFichaPartidoClub) {
        this.$router.push({ name: 'fichaDePartidoDetail', params: { partidoId: this.expediente.match.id } })
      }
    },
    goToInforme () {
      if (this.$store.state.permissions.canViewInformesAuditorias && this.expediente.informe) {
        this.$router.push({ name: 'informe-auditoria', params: { id: this.expediente.informe } })
      }
    }
  }
}
</script>

<style scoped>
.container {
  display: grid;
  grid-template-columns: 0.8fr repeat(2, 1.5fr);
  grid-template-rows: 0.3fr 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  border-top: 20px solid #293968;
  /* #0BB9D8 */
  background-color: #f6f6f6;
  border-radius: 30px;
  box-shadow: 0px 13px 44px -19px rgba(0, 0, 0, 0.21);
  -webkit-box-shadow: 0px 13px 44px -19px rgba(0, 0, 0, 0.21);
  -moz-box-shadow: 0px 13px 44px -19px rgba(0, 0, 0, 0.21);
}

.club {
  grid-area: 1 / 1 / 3 / 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  font-size: 18px;
}

.club-name {
  padding-top: 5px;
}

.description {
  grid-area: 1 / 2 / 2 / 4;
  text-align: center;
  font-size: 24px;
}

.expediente-info {
  grid-area: 2 / 2 / 3 / 3;
  font-size: 16px;
}

.expediente-partido-info {
  grid-area: 2 / 3 / 3 / 4;
  font-size: 16px;

}

.link-style {
  color: #3984e8;
  cursor: pointer;
}</style>
